<div class="generic-modal-root" >

    <div class="row-padding">
      <div class="row" style="margin-top: 0;">
          <h3 style="text-align: center; font-weight: 300;">Choose the accounts you want to link to this {{accountType}} </h3>
          <table class="account-table">  
            <tr *ngFor="let account of linkableAccounts">         
                <td class="account-name" >
                    <span>{{account.accountName}}</span>
                </td>
                <td style="padding: 15px; justify-content: center; display: flex;">
                    <chunky-check-box [(checked)]="account.linked"></chunky-check-box>
                </td>
            </tr>            
        </table>
      </div>
    </div>
  
  
    <div style="height: 45px;">
      <button (click)="close()" class="btn btn-danger" style="margin-left: 15px;float: right;margin-top: 10px;">Cancel</button>
      <button (click)="saveAndClose()" class="btn btn-success" style="margin-left: 15px;float: right;margin-top: 10px;">Save</button>
    </div>
  </div> 